import React from "react";
import * as Icon from "react-feather";
import { FaBed } from "react-icons/fa";
const getNavigationConfig = (clinicUserinfo) => {
  if (clinicUserinfo?.isPetHospitalization == true) {
    return (
      [
        {
          type: "groupHeader",
          groupTitle: "",
        },

        {
          id: "home",
          title: "Anasayfa",
          type: "item",
          icon: <Icon.Home size={20} />,
          permissions: ["admin", "editor", "isPetHospitalization"],
          navLink: "/home",
        },

        {
          type: "groupHeader",
          groupTitle: "Randevu Yönetimi",
        },
        {
          id: "Randevu",
          title: "Randevu",
          type: "item",
          icon: <Icon.Calendar size={20} />,
          permissions: ["admin", "editor"],
          navLink: "/yenirandevu",
        },
        {
          type: "groupHeader",
          groupTitle: "Hasta İşlemleri",
        },
        {
          id: "NewRecord",
          title: "Hasta Listesi",
          type: "item",
          icon: <Icon.PlusSquare size={20} />,
          permissions: ["admin", "editor"],
          navLink: "/hastalistesi",
        },
        {
          type: "groupHeader",
          groupTitle: "Yatan Hasta Modülü",
          permissions: ["isPetHospitalization"],
        },
        {
          id: "yataklar",
          title: "Yataklar",
          type: "item",
          icon: <FaBed size={20} />,
          navLink: "/yataklar",
          permissions: ["admin", "editor"],
        },
        {
          id: "yatakkategori",
          title: "Yatak Kategorisi",
          type: "item",
          icon: <Icon.AlignJustify size={20} />,
          navLink: "/yatakkategori",
          permissions: ["admin", "editor"],
        },
        {
          type: "groupHeader",
          groupTitle: "ÖNERİ",
        },
        {
          id: "oneriolustur",
          title: "Öneri Oluştur",
          type: "item",
          icon: <Icon.HelpCircle size={20} />,
          permissions: ["admin", "editor"],
          navLink: "/oneriolustur",
        },
        {
          type: "groupHeader",
          groupTitle: "KLİNİK",
        },
        {
          id: "ClinicRead",
          title: "Klinik Bilgileri",
          type: "item",
          icon: <Icon.PlusSquare size={20} />,
          permissions: ["admin", "editor"],
          navLink: "/klinik-bilgileri",
        },
        {
          id: "ClinicChat",
          title: "Mesajlar",
          type: "item",
          icon: <Icon.MessageCircle size={20} />,
          permissions: ["admin", "editor"],
          navLink: "/ClinicChat",
        },
        {
          id: "VeterinerRead",
          title: "Veteriner Bilgileri",
          type: "item",
          icon: <Icon.Users size={20} />,
          permissions: ["admin", "editor"],
          navLink: "/Veterinerler",
        },
        {
          id: "Licence",
          title: "Paketler",
          type: "item",
          icon: <Icon.Tag size={20} />,
          permissions: ["admin"],
          navLink: "/Licence",
        },
        {
          id: "Payment",
          title: "Ödeme Yöntemleri",
          type: "item",
          icon: <Icon.CreditCard size={20} />,
          permissions: ["admin"],
          navLink: "/payment",
        },

      ]
    )
  }
  else {
    return (
      [
        {
          type: "groupHeader",
          groupTitle: "",
        },

        {
          id: "home",
          title: "Anasayfa",
          type: "item",
          icon: <Icon.Home size={20} />,
          permissions: ["admin", "editor", "isPetHospitalization"],
          navLink: "/home",
        },

        {
          type: "groupHeader",
          groupTitle: "Randevu Yönetimi",
        },
        {
          id: "Randevu",
          title: "Randevu",
          type: "item",
          icon: <Icon.Calendar size={20} />,
          permissions: ["admin", "editor"],
          navLink: "/yenirandevu",
        },
        // {
        //   id: "KlinikRandevu",
        //   title: "Klinik Randevu",
        //   type: "item",
        //   icon: <Icon.Archive size={20} />,
        //   permissions: ["admin", "editor"],
        //   navLink: "/KlinikRandevu",
        // },
        {
          type: "groupHeader",
          groupTitle: "Hasta İşlemleri",
        },
        {
          id: "NewRecord",
          title: "Hasta Listesi",
          type: "item",
          icon: <Icon.PlusSquare size={20} />,
          permissions: ["admin", "editor"],
          navLink: "/hastalistesi",
        },
        // {
        //   id: "SahipBilgileri",
        //   title: "Yeni Sahipli Pet Kayıdı",
        //   type: "item",
        //   icon: <Icon.PlusCircle size={20} />,
        //   permissions: ["admin", "editor"],
        //   navLink: "/SahipBilgileri",
        // },
        // {
        //   id: "Paciente",
        //   title: "Hastalarımız",
        //   type: "item",
        //   icon: <Icon.FolderPlus size={20} />,
        //   permissions: ["admin", "editor"],
        //   navLink: "/Paciente",
        // },
        // {
        //   type: "groupHeader",
        //   groupTitle: "Ürün Yönetimi",
        // },
        // {
        //   id: "UrunListesi",
        //   title: "Ürün Listesi",
        //   type: "item",
        //   icon: <Icon.AlignJustify size={20} />,
        //   permissions: ["admin", "editor"],
        //   navLink: "/urunlistesi",
        // },

        // {
        //   type: "groupHeader",
        //   groupTitle: "Tanımlamalar",
        // },
        // {
        //   id: "urunkategori",
        //   title: "Ürün Kategori",
        //   type: "item",
        //   icon: <Icon.FilePlus size={20} />,
        //   permissions: ["admin", "editor"],
        //   navLink: "/urunkategoritanimlama",
        // },
        // {
        //   id: "urundepe",
        //   title: "Ürün Depo",
        //   type: "item",
        //   icon: <Icon.PlusCircle size={20} />,
        //   permissions: ["admin", "editor"],
        //   navLink: "/depotanimlama",
        // },
        {
          type: "groupHeader",
          groupTitle: "ÖNERİ",
        },
        {
          id: "oneriolustur",
          title: "Öneri Oluştur",
          type: "item",
          icon: <Icon.HelpCircle size={20} />,
          permissions: ["admin", "editor"],
          navLink: "/oneriolustur",
        },
        {
          type: "groupHeader",
          groupTitle: "KLİNİK",
        },
        {
          id: "ClinicRead",
          title: "Klinik Bilgileri",
          type: "item",
          icon: <Icon.PlusSquare size={20} />,
          permissions: ["admin", "editor"],
          navLink: "/klinik-bilgileri",
        },
        {
          id: "ClinicChat",
          title: "Mesajlar",
          type: "item",
          icon: <Icon.MessageCircle size={20} />,
          permissions: ["admin", "editor"],
          navLink: "/ClinicChat",
        },
        {
          id: "VeterinerRead",
          title: "Veteriner Bilgileri",
          type: "item",
          icon: <Icon.Users size={20} />,
          permissions: ["admin", "editor"],
          navLink: "/Veterinerler",
        },
        {
          id: "Licence",
          title: "Paketler",
          type: "item",
          icon: <Icon.Tag size={20} />,
          permissions: ["admin"],
          navLink: "/Licence",
        },
        {
          id: "Payment",
          title: "Ödeme Yöntemleri",
          type: "item",
          icon: <Icon.CreditCard size={20} />,
          permissions: ["admin"],
          navLink: "/payment",
        },

      ]
    )
  }
}

export default getNavigationConfig
